// Shared labels/colours for the Pledges module.

export const PLEDGE_STATUSES = {
  new: { label: 'New', bg: 'info' },
  awaiting_follow_up: { label: 'Awaiting Follow-Up', bg: 'warning' },
  payment_scheduled: { label: 'Payment Scheduled', bg: 'primary' },
  active: { label: 'Active', bg: 'primary' },
  partially_paid: { label: 'Partially Paid', bg: 'info' },
  fulfilled: { label: 'Fulfilled', bg: 'success' },
  on_hold: { label: 'On Hold', bg: 'secondary' },
  cancelled: { label: 'Cancelled', bg: 'danger' }
};

export const PLEDGE_FREQUENCIES = {
  one_off: 'One-Off',
  monthly: 'Monthly',
  annually: 'Annually'
};

export const PLEDGE_SOURCES = {
  event: 'Event',
  phone: 'Phone',
  website: 'Website',
  referral: 'Referral',
  campaign: 'Campaign',
  other: 'Other'
};

export const PLEDGE_PRIORITIES = {
  normal: { label: 'Normal', bg: 'secondary' },
  high: { label: 'High', bg: 'warning' },
  urgent: { label: 'Urgent', bg: 'danger' }
};

export const CONTACT_METHODS = {
  phone: 'Phone',
  email: 'Email',
  sms: 'SMS',
  in_person: 'In Person'
};

export const pledgeRef = pledge =>
  pledge?.simple_id ? `PL${pledge.simple_id}` : '';

export const donorFullName = donor =>
  [donor?.first_name, donor?.last_name].filter(Boolean).join(' ') || '-';
